import { Metrics } from '@/lib/metrics'


export const tabMetrics = new Metrics()
